import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import {
  FiberManualRecord as StatusIcon,
  CloudOff as OfflineIcon
} from '@mui/icons-material';

/**
 * ConnectionStatus Component
 * Displays Socket.IO connection status
 */
const ConnectionStatus = ({ isConnected, error = null }) => {
  if (isConnected) {
    return (
      <Chip
        icon={<StatusIcon sx={{ fontSize: 12 }} />}
        label="Connected"
        size="small"
        color="success"
        variant="outlined"
      />
    );
  }

  return (
    <Chip
      icon={<OfflineIcon sx={{ fontSize: 12 }} />}
      label={error || 'Disconnected'}
      size="small"
      color="error"
      variant="outlined"
    />
  );
};

export default ConnectionStatus;
